import { Theme } from '@mui/material/styles'

import { textHover } from '../hover'

// ----------------------------------------------------------------------
// A link is the text answer to the pointer: an underline, and a step of ink.
//
// This file used to be a `defaultProps` and nothing else, which left MUI's own
// `underlineHover` carrying the whole affordance — no ink step, no transition,
// and nothing at all on a link that asked for `underline="none"`. So three
// screens grew a `styled(Link)` of their own to put the ink step back, each
// with its own idea of which ink.
//
// The underline is stated here rather than left to the prop, so a link answers
// whatever a caller does with `underline`. A link that is drawn as a surface —
// one wrapping a whole card or a chip — opts out with `underline="none"` and
// takes the surface answer from the thing it wraps instead.
// ----------------------------------------------------------------------

export default function Link(theme: Theme) {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover' as const,
      },
      styleOverrides: {
        // The accent's own dark is the ink a navigable thing steps to. It is
        // also what the three screen-level copies of this were reaching for,
        // spelled `primary.dark` in each of them.
        root: textHover(theme, theme.palette.primary.dark),
        // `underline="none"` is asked for by a link that is drawn as something
        // else — one wrapping a chip, a card or a row. It keeps the ink step,
        // so it still answers the pointer, and drops the rule that would draw
        // a line under the object it wraps.
        underlineNone: {
          '&:hover': {
            textDecoration: 'none',
          },
        },
      },
    },
  }
}
